module.exports = __webpack_public_path__ + "static/media/metro.a5a2b867.svg";